export default {"src":"/_next/static/media/elevate.b72cb977.svg","height":165,"width":165};